export default "__VITE_ASSET__D_vVJ4r5__"